<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .modal(:class="{ 'is-active' : muestraModalExcelSaldo }")
      .modal-background(@click="closeModalExcelSaldo")
      .card
        header.card-header
          p.card-header-title
            span Periodo y Mes
        .card-content
          .content
            .column.is-12
              .columns
                .column.is-6
                  label.label.is-small.has-text-left Mes
                  .d-flex.width-100
                    .flex-1
                      .select.is-small.d-flex
                        select.flex-1(v-model='mesExportar', :disabled='isLoading')
                          option(:value='item.id', v-for="(item, index) in arrayMeses") {{item.id + ' - ' + item.nombre}}
                .column.is-6
                  label.label.is-small.has-text-left Periodo
                  .d-flex.width-100
                    .flex-1
                      .select.is-small.d-flex
                        select.flex-1.width-600(v-model='periodoExportar', :disabled='isLoading')
                          option(:value='item.id', v-for="(item, index) in arrayYear") {{item.nombre}}
        footer.card-footer
          button.button.card-footer-item.is-outlined.info-box-button.is-uppercase(@click="closeModalExcelSaldo") Cancelar
          template
            button.button.card-footer-item.is-primary.is-outlined.info-box-button.is-uppercase(@click="fetchExportarExcelSaldo()", :disabled="isLoading", :class="{'is-loading' : isLoading}")
              span Exportar
    .title
      span Empleados
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret(@click="mostrarFiltros = !mostrarFiltros")
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)

          .filtros(v-if="mostrarFiltros", key="filtros")
            .filtro
              .codigo-empleado
                .control.title-singular
                  p Codigo de empleado
                  .input-container
                    input.input(
                      type="number",
                      v-model="filtroCodigoEmpleado"
                    )
                    span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                      i.fa.fa-search
                    .erase-data(@click="filtroCodigoEmpleado = ''")
                      .icon
                        .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaEmpleado"
                    )
                      lookup-small-empleado(
                        @selected="seleccionarEmpleado"
                        @close="mostrarBusquedaEmpleado = false"
                        :codigo="filtroCodigoEmpleado"
                      )
            .filtro
              .title-singular
                p Urgencia
              .status-container-filtro
                .status(
                  v-for="o in filtrosUrgencia"
                  :class="{'selected': o === filtroUrgencia}"
                  @click="filtroUrgencia = o"
                )
                  .circle(
                    :class="o"
                  )

          .boton-container(key="boton-container")
            button.button(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar
            button.button.margin-button-top(@click="exportarExcel")
              span.icon.is-small
                i.fa.fa-file-excel-o.fa-fw.fa-lg
              span Exportar Excel
            button.button.margin-button-top(@click="showModalExportarExcelSaldo")
              span.icon.is-small
                i.fa.fa-file-excel-o.fa-fw.fa-lg
              span Exportar Saldo Vacaciones
      .body(key="body")
        .is-loading(v-if="isLoading")
          .icon
            i.fa.fa-spinner.fa-spin
        .information(v-else)
          .is-desktop
            table.table.is-striped.is-bordered
              thead
                th Empleado
                th Fecha de Ingreso
                th
                  span Días por tomar / programar
                th DNI
                th Jefe
                th.td-status
              tbody(
                name="table-row"
                is="transition-group"
              )
                tr.row-table(
                  v-for="(o, index) in listaFiltrada"
                  :key="index+'-desktop'"
                )
                  td
                    span.name {{ o.nombre }}
                    span.email  ({{ o.cargo }})
                    br
                    span.email {{ o.email }}
                  td {{ o.fechaIngreso }}
                  td {{ o.diasReales }} / {{ o.diasDisponibles }}
                  td {{ o.dni }}
                  td
                    span.name.hint--top(:aria-label="'Jefe: ' + o.dniJefe") {{ o.nombreJefe }}
                    br
                    span.email {{ o.emailJefe }}
                  td.td-status
                    .status
                      .circle(
                        :class=`{
                          'yellow' : o.diasDisponibles >= 35 && o.diasDisponibles <= 40,
                          'red' : o.diasDisponibles > 40
                        }`
                      )
          .is-mobile
            .box.has-text-left(
                v-for="(o, index) in listaFiltrada"
                :key="index+'-mobile'"
              )
              .dias
                span
                  strong {{ o.diasReales }}&nbsp;
                  span por tomar /&nbsp;
                  strong {{ o.diasDisponibles }}&nbsp;
                  span por programar&nbsp;
                .status
                  .circle(
                    :class=`{
                      'yellow' : o.diasDisponibles >= 35 && o.diasDisponibles <= 40,
                      'red' : o.diasDisponibles > 40
                    }`
                  )
              div.mt-10
                span.name {{ o.nombre }}
              div
                span.text-small Cargo:&nbsp;
                span {{ o.cargo }}
              div
                span.text-small Email:&nbsp;
                span {{ o.email }}
              div
                span.text-small Fecha de Ingreso:&nbsp;
                span {{ o.fechaIngreso }}
              div
                span.text-small DNI:&nbsp;
                span {{ o.dni }}
              div
                span.text-small Jefe:&nbsp;
                span.name.hint--top(:aria-label="'Jefe: ' + o.dniJefe") {{ o.nombreJefe }}
              div
                span.text-small Email Jefe:&nbsp;
                span {{ o.emailJefe }}
          div(
              v-if="listaFiltrada.length === 0 || listaFiltrada.length === -1 || listaFiltrada.length === undefined"
            )
            .message.is-warning
              .message-body No hay empleados que cumplan con los siguientes filtros
</template>

<script>
import mt                               from 'moment'
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import { apiGet, notify, apiGetExcel } from '../util/general'
export default {
  name: 'lista_empleados_vacaciones_component',
  data () {
    return {
      lista                       : [],
      listaFiltrada               : [],
      isLoading                   : false,
      mostrarBusquedaEmpleado     : false,
      mostrarFiltros              : true,
      mostrarConfirmacionNoLoTomo : false,
      empleadoSeleccionado        : {},
      filtroCodigoEmpleado        : '',
      filtroUrgencia                : 'white',
      filtrosUrgencia : [
        'white',
        'green',
        'yellow',
        'red'
      ],
      muestraModalExcelSaldo    : false,
      mesExportar               : '',
      periodoExportar           : '',
      arrayMeses  : [
        {id: '1', nombre: 'Enero'},
        {id: '2', nombre: 'Febrero'},
        {id: '3', nombre: 'Marzo'},
        {id: '4', nombre: 'Abril'},
        {id: '5', nombre: 'Mayo'},
        {id: '6', nombre: 'Junio'},
        {id: '7', nombre: 'Julio'},
        {id: '8', nombre: 'Agosto'},
        {id: '9', nombre: 'Setiembre'},
        {id: '10', nombre: 'Octubre'},
        {id: '11', nombre: 'Noviembre'},
        {id: '12', nombre: 'Diciembre'}
      ],
      arrayYear: Array.from({ length: (mt().year() - 2020 + 1) }, (_, i) => {
        var year = mt().year() - i;
        return { id: year, nombre: String(year) };
      })
    }
  },
  components: {
    LookupSmallEmpleado
  },
  created () {
    this.limpiarFiltros()
    this.fetch()
  },
  watch : {
    filtroCodigoEmpleado (value) {
      return this.fetch()
    },
    filtroUrgencia (value) {
      return this.filtrarUrgencia()
    }
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      vm.listaFiltrada = []

      var filtros = {
        codigoEmpleado : vm.filtroCodigoEmpleado
      }

      var obj = {
        filtros: filtros
      }
      apiGet(vm, '/vacaciones/empleado', obj, function (data) {
        vm.lista = data.lista
        if (vm.filtroUrgencia !== 'white') {
          vm.filtrarUrgencia()
        } else {
          vm.listaFiltrada = vm.lista
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtroCodigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtroCodigoEmpleado = ''
      this.filtroUrgencia = 'white'
    },
    filtrarUrgencia () {
      var vm = this
      // Hacemos el filtro local
      if (vm.filtroUrgencia === 'white') {
        vm.listaFiltrada = vm.lista
      } else {
        if (vm.filtroUrgencia === 'green') {
          vm.listaFiltrada = vm.lista.filter(e => {
            return e.diasDisponibles < 35
          })
        } else if (vm.filtroUrgencia === 'yellow') {
          vm.listaFiltrada = vm.lista.filter(e => {
            return e.diasDisponibles >= 35 && e.diasDisponibles <= 40
          })
        } else if (vm.filtroUrgencia === 'red') {
          vm.listaFiltrada = vm.lista.filter(e => {
            return e.diasDisponibles > 40
          })
        }
      }
    },
    exportarExcel () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      let obj = {
        codigoEmpleado : vm.filtroCodigoEmpleado
      }
      apiGetExcel(vm, '/vacaciones/empleado/vacacionesReporte', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'reporteVacacionesEmpleado' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    showModalExportarExcelSaldo () {
      var vm = this
      vm.muestraModalExcelSaldo = true
    },
    closeModalExcelSaldo () {
      var vm = this
      vm.mesExportar = ''
      vm.periodoExportar = ''
      vm.muestraModalExcelSaldo = false
    },
    fetchExportarExcelSaldo () {
      var vm = this
      if (!vm.mesExportar) {
        notify(vm, 'error', 'Error', 'Mes es Obligatorio')
        return
      }
      if (!vm.periodoExportar) {
        notify(vm, 'error', 'Error', 'Periodo es Obligatorio')
        return
      }
      vm.isLoading = true
      let obj = {
        codigoEmpleado : vm.filtroCodigoEmpleado,
        mes            : vm.mesExportar,
        periodo        : vm.periodoExportar
      }
      apiGetExcel(vm, '/vacaciones/empleado/vacacionesReporteSaldo', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'reporteVacacionesEmpleadoSaldo' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
        vm.closeModalExcelSaldo()
        // window.open(url);
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display none
    .box
      position: relative
  .text-small
    font-size 12px
    color #9a9a9a
  @media (max-width 935px)
    .filtros-container
      .filtros
        flex-direction: column
        .filtro
          width 100%
    .is-mobile
      display block
    .is-desktop
      display none

    .dias
      display flex
      position: absolute
      top: 3px
      right: 6px
      align-items: center
      .status
        .circle
          width: 15px;
          height: 15px;

    .name
      font-size: 16px;
.width-600
  width: 600px;

</style>



// WEBPACK FOOTER //
// Component_Reporte_Lista_Empleados_Vacaciones.vue?308aca76